import { deleteDefinition } from "state/grid/util";
import {
  DELETE_DEFINITION,
  REQUEST_BOOK_BASIS_VALUES,
  RECEIVE_BOOK_BASIS_VALUES,
  SET_DEFINITION,
  SET_DEFINITIONS,
  REQUEST_BOOK_ANALYTICS_DATA,
  RECEIVE_BOOK_ANALYTICS_DATA,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actions";
import { produce } from "immer";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },

  fetchingBookBasisValues: false,
  bookBasisValues: [],
  fetchingBookAnalyticsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  bookAnalyticsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }

    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.bookAnalyticsData = defaultState.bookAnalyticsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_BOOK_ANALYTICS_DATA: {
      state.fetchingBookAnalyticsData[action.summary] = true;
      state.bookAnalyticsData[action.summary] =
        defaultState.bookAnalyticsData[action.summary];
      break;
    }
    case RECEIVE_BOOK_ANALYTICS_DATA: {
      state.fetchingBookAnalyticsData[action.summary] = false;
      state.bookAnalyticsData[action.summary] = action.data;
      break;
    }

    case REQUEST_BOOK_BASIS_VALUES: {
      state.fetchingBookBasisValues = true;
      state.bookBasisValues = defaultState.bookBasisValues;
      break;
    }
    case RECEIVE_BOOK_BASIS_VALUES: {
      state.fetchingBookBasisValues = false;
      state.bookBasisValues = action.data;
      break;
    }

    default:
      return state;
  }
});
